import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "image", "filename"]

  connect() {
    this.objectUrl = null
  }

  disconnect() {
    this.revokeObjectUrl()
  }

  show() {
    const file = this.inputTarget.files[0]

    if (!file || !file.type.startsWith("image/")) {
      this.clear()
      return
    }

    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.objectUrl
    this.imageTarget.alt = `${file.name} のプレビュー`
    this.filenameTarget.textContent = file.name
    this.previewTarget.hidden = false
  }

  clear() {
    this.inputTarget.value = ""
    this.imageTarget.removeAttribute("src")
    this.imageTarget.alt = ""
    this.filenameTarget.textContent = ""
    this.previewTarget.hidden = true
    this.revokeObjectUrl()
  }

  revokeObjectUrl() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }
}
